import React  from 'react'
import { Link } from 'react-router-dom';




const GrassrootForAfrica = () => {  
  return (
    <section style={{backgroundColor:'rgba(255, 255, 255, 1)'}} className='seven-year-model'>
                <div className="container">
                    <div className="row">
                        <div className="seven-year-model-image col-lg-9 col-12 bg-primary">
                            {/* <img  src='img/africa-map-with-flags.png'  style={{borderRadius:'10px'}} className="" alt="" /> */}
                            <img  src='img/Herbal.png'  style={{borderRadius:'10px'}} className="volunteer-image img-fluid" alt="" />

                            {/* frontend\public\img\Flag_map_of_africa-removebg-preview.png */}
                        </div>

                        <div className="col-lg-3 col-12 d-flex flex-column justify-content-center">
                            <h2 className="mb-2 mt-2 text-center">Driving Change Through Local Innovation</h2>
                                {/* <h6 className="mb-4"> Grassroot Innovation Learnings & Insights </h6> */}
                                <h6 className="text-center"> (Local Knowledge, Lasting Change) </h6>                                
                                    {/* To design & implement collectively a Model 7 - year Comprehensive Development Plan for Your Community & People */}
                                    <p>Africa’s greatest solutions lie within its own people. At PHG Africa, we champion and strengthen home-grown innovations to address the continent’s unique challenges. With deep insights, proven experience, and a vibrant network of local innovators, we stand as a trusted partner to Governments and Developmental Organizations, ready to co-create impactful solutions that uplift communities and drive sustainable development.</p>
                                        {/* —transforming ideas into impactful, sustainable change from the ground up.</p> */}
                                    {/* <p>It has been shown that Africa's problems can be addressed by empowering and augmenting home-grown solutions to tackle the unique problems facing the land. That is why PHG Africa has positioned itself as an insightful developmental partner with in-depth Learnings and Experience in this landscape, ready to assist Government Bodies and Developmental Partners to address local problems through our Diverse Network of Local Innovators. </p> */}
                                {/* <p>How they will utilize Grassroot in Development, How they will use the Bottom up Approach to reach conmmunities in-terms of Economic and Development. We offer these consultancies, W etrain and equip and offer consultancies for organizations who will want to utilize the. Policies Directions for Governments and Organuzations. We charge in Dollars.  </p> */}
                                {/* to={'/seven-year-model'} */}
                               <Link style={{textAlign:'center'}}  to={"/grassroot-for-africa-form"}>
                                  <button style={{width:'70%'}} className='btn btn-primary p-2'>Start a Partnership</button>
                                </Link>                            
                        </div>                       
                    </div>
                </div>
            </section>
  )
}

export default GrassrootForAfrica







        
     

